import categories from './categories';
import sellers from './sellers';
import sellerHomologations from './seller-homologations'

export default {
  categories,
  sellers,
  sellerHomologations
}